import { render, staticRenderFns } from "./C1PaginatorShowingResults.vue?vue&type=template&id=1a5c9f8c&"
import script from "./C1PaginatorShowingResults.vue?vue&type=script&lang=js&"
export * from "./C1PaginatorShowingResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports